import { CreditConditional } from '@indigo-ag/schema';
import { creditConditionalsTranslations } from 'shared/constants';

export const getConditionalText = (conditional: string | CreditConditional) => {
  if (Object.values(CreditConditional).includes(conditional as CreditConditional)) {
    return creditConditionalsTranslations[conditional as CreditConditional];
  }
  return `${creditConditionalsTranslations[CreditConditional.OTHER]}: ${conditional}`;
};
